
























import Vue from "vue";
import iwAccordion from "@/encoding/components/Accordion.vue";
import iwInputCheckboxGroup from "@/encoding/components/buildingBlocks/InputCheckboxGroup.vue";
import iwFloorAreaWorkspace from "./FloorAreaWorkspace.vue";

export default Vue.extend({
    components: {
        iwAccordion: iwAccordion,
        iwInputCheckboxGroup: iwInputCheckboxGroup,
        iwFloorAreaWorkspace: iwFloorAreaWorkspace
    },
    data: function() {
        return {
            pathInStoreExists: "property.specificities.SME.workSpace.exists",
            pathInStoreFloorAreaWorkspace: "property.specificities.SME.workSpace.surface",
            checkboxes: [
                {
                    value: "hasWorkspace",
                    label: "is_there_a_workspace"
                }
            ]
        };
    },
    computed: {
        isDisplayed: function(): boolean {
            return ["HOUSE", "APARTMENT", "COMMERCIAL", "OFFICE", "INDUSTRY","HOMES_TO_BUILD", "OTHER"].indexOf(this.getPropertyType()) !== - 1;
        },
        valueChecked: function(): Array<string> | void {
            if (this.$store.getters["FormModule/getValue"](this.pathInStoreExists)) {
                return ["hasWorkspace"];
            }
        },
        getErrorMessage: function(): string|null {
            return this.$store.getters["FormModule/getErrorObjectByPath"](this.pathInStoreExists) || this.$store.getters["FormModule/getErrorObjectByPath"](this.pathInStoreFloorAreaWorkspace);
        },
        isOpen: function(): boolean {
            let isOpen = false;

            if(this.valueChecked && this.valueChecked.length > 0) {
                isOpen = true;
            }
            return isOpen;
        },
        floorAreaWorkspaceInput: function(): Vue | void {
            const accordionComponent = this.$refs.floorAreaWorkspace as Vue;
            if(accordionComponent !== null) {
                const accordionInput = accordionComponent.$refs.floorAreaWorkspaceInput as Vue;
                if(accordionInput !== null) {
                    return accordionInput;
                }
            }
        }
    },
    mounted: function() {
        if (this.$store.getters["FormModule/getValue"](this.pathInStoreExists) == null && this.isDisplayed) {
            this.$store.dispatch("FormModule/addValue", {path: this.pathInStoreExists, value: false});
        }
    },
    methods: {
        updateValueFloorAreaWorkspace: function(floorAreaWorkspace: number): void {
            if (floorAreaWorkspace == 0 && this.$store.getters["FormModule/getValue"](this.pathInStoreFloorAreaWorkspace) != null) {
                this.$store.commit("FormModule/deleteValue", this.pathInStoreFloorAreaWorkspace);
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStoreFloorAreaWorkspace, "value": floorAreaWorkspace});
            }
        },
        updateValue: function(selectedValues:  Array<string>): void {
            if(selectedValues.length > 0) {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStoreExists, "value": true});
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStoreExists, "value": false});
                if(this.floorAreaWorkspaceInput) {
                    this.floorAreaWorkspaceInput.$data.internalInput = 0;
                }
                this.$store.commit("FormModule/deleteValue", this.pathInStoreFloorAreaWorkspace);
            }
        }
    },
});
